export default __webpack_public_path__ + "static/travelbureau-5964ad26708e1b402a9ab47fef692c03.png";